module.exports = __webpack_public_path__ + "img/jazda-testowa.2ca99d24.webp";